import React from "react";
import PropTypes from 'prop-types';
import {get} from './Storage';
import News from './News';
import css from '../topnews.less';

var AppSettings = get();

class NewsList extends React.Component{

    constructor(props, context){
        super(props);
        this.state = {
            data: props.data
        }        
    }
    componentDidMount(){
         
    }
    shouldComponentUpdate(nextProps, nextState){
        return true;
    }

    componentWillReceiveProps(nextProps){
        this.setState({
            data: nextProps.data
        });
    }
    
    render(){

        var newsNodes = "";
        if (this.state.data.length > 0) {
            let news = this.state.data[0]
            newsNodes = <News documents={news.documents} setReadByuser={news.setReadByuser} hasToBeConfirmed={news.hasToBeConfirmed} id={news.id} text={news.text} date={news.date} url={news.links[0].href} key={news.id} title={news.subject} />
                /*
                newsNodes = this.state.data.map(function (news, i) {
                return (
                     <News id={news.id} date={news.date} url={news.links[0].href} key={news.id} title={news.subject} />
                )
            }.bind(this));*/
        }
        var messageInfo = <div className="news-info"> 
                            <i className="fa fa-envelope-o" aria-hidden="true"></i>&nbsp;
                            Hai <strong>{this.state.data.length}</strong> nuov{this.state.data.length==1?"o":"i"} messagg{this.state.data.length==1?"io":"i"} da leggere
                          </div>;
        return(
            <div className="news-list">
                {messageInfo}
                {newsNodes}
            </div>
        )
    }
}

NewsList.displayName = "NewsListComponent";

// PropTypes validation
NewsList.propTypes = {
    data: PropTypes.array.isRequired,
};

// default props
NewsList.defaultProps = {
};

export default NewsList;